module.exports = __webpack_public_path__ + "img/a15.d26b241b.svg";